export interface FormSubmission {
  formType: 'conversion_copy' | 'brand_scaling';
  timestamp: Date;
  data: Record<string, any>;
}

// Function to notify Cleo (chatbot) about form submission
export const notifyCleoOfFormSubmission = (
  formType: 'conversion_copy' | 'brand_scaling',
  formData: Record<string, any>
) => {
  const submission: FormSubmission = {
    formType,
    timestamp: new Date(),
    data: formData
  };

  // Dispatch a custom event that Cleo will listen for
  const event = new CustomEvent('formSubmitted', {
    detail: submission
  });

  window.dispatchEvent(event);
};
